import React from 'react';
import ReactDOM from 'react-dom/client';
// Police auto-hébergée (pas de requête vers Google Fonts) : fichier variable
// unique couvrant les graisses 100-900, découpé par plage Unicode.
import '@fontsource-variable/inter';
import './styles/tailwind.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker (PWA) — uniquement en production.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.error('Échec enregistrement du service worker :', err));
  });
}
